module.exports = __webpack_public_path__ + "img/imgtaskgot.18862221.png";